import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import { observer } from "mobx-react-lite";
import Section from "views/common/section";
import { ButtonToolbar, Form } from "react-bootstrap";
import { translateGeneral } from "utils/localizations";
import Button from "@edaz/edazkit/Button";
import { preventDefault } from "@frui.ts/views/dist";
import BankTransferRefundSection from "../../common/bankTransferRefundSection";
import PayGateRefundSection from "../../common/payGateRefundSection";

const RefundSection: ViewComponent<CustomerRefundCandidateDetailViewModel> = observer(({ vm }) => {
  const buttons = (
    <ButtonToolbar className="ml-auto">
      {vm.hasUnsavedChanges && (
        <Button size="sm" className="rounded text-light" variant="link" onClick={vm.onCancelTransferRefundModificationClick}>
          {translateGeneral("cancelUnsavedChanges")}
        </Button>
      )}
      {vm.isUserAllowedToEdit && (
        <Button key="save" size="sm" className="rounded" disabled={!vm.hasUnsavedChanges} type="submit">
          {translateGeneral("saveChanges")}
        </Button>
      )}
    </ButtonToolbar>
  );

  return (
    <Form onSubmit={preventDefault(vm.save)}>
      <Section context={vm.item} title={vm.translate("refund")} buttons={buttons}>
        {vm.isPayGateRefund ? <PayGateRefundSection vm={vm} /> : <BankTransferRefundSection vm={vm} />}
      </Section>
    </Form>
  );
});

export default RefundSection;
